import type { TechSupportMetrics } from "@expert/sales-tools";

import { getLogger } from "@expert/logging";

import { getGamificationApiClient } from "@/sales-tools/api/api";

import { getYesterdayTimeframe } from "./getYesterdayTimeframe";

const logger = getLogger({ module: "getYesterdayPerformanceMetrics" });

type EmployeeWithMetrics = { metrics?: { techSupport?: TechSupportMetrics } };

export function hasEmployeeMetrics(data: unknown): data is { employee: EmployeeWithMetrics } {
    return (
        typeof data === "object" &&
        data !== null &&
        "employee" in data &&
        typeof (data as Record<string, unknown>).employee === "object" &&
        (data as Record<string, unknown>).employee !== null
    );
}

export const getYesterdayPerformanceMetrics = async (): Promise<TechSupportMetrics | null> => {
    const { start, end } = getYesterdayTimeframe();

    const resp: unknown = await getGamificationApiClient()
        .get("v1/performance", { searchParams: { start, end }, retry: 0 })
        .json();

    if (!hasEmployeeMetrics(resp)) {
        logger.warn(
            { start, end, responseKeys: resp ? Object.keys(resp as object) : null },
            "Morning paper: gamification API response did not match expected shape",
        );
        return null;
    }

    return resp.employee.metrics?.techSupport ?? null;
};
